import { useEffect, useState } from "react";
import { useLang } from "../../core/lang";
import LangKeys from "../../core/locales/keys";
import { getBusinessProfile } from "../../services/dashboardApi";

function DeleteKhataPage() {
  const { t } = useLang();

  const [loading, setLoading] =
    useState(true);

  const [businessName, setBusinessName] =
    useState("");

  const [value, setValue] =
    useState("");

  const [canDelete, setCanDelete] =
    useState(false);

  const [deleting, setDeleting] =
    useState(false);

  // =====================================================
  // LOAD BUSINESS PROFILE
  // =====================================================

  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = async () => {
    try {
      setLoading(true);

      const res =
        await getBusinessProfile();

      if (res?.success && res?.data) {
        setBusinessName(
          res.data.business_name || ""
        );
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  // =====================================================
  // CHECK MATCH
  // =====================================================

  const checkMatch = (v) => {
    setValue(v);

    setCanDelete(
      v.trim() === businessName
    );
  };

  // =====================================================
  // GET TOKEN
  // =====================================================

  const getToken = () => {
    return (
      localStorage.getItem("token") ||
      localStorage.getItem("login_token") ||
      ""
    );
  };

  // =====================================================
  // DELETE ACTION
  // =====================================================

  const confirmDelete = async () => {
    if (!canDelete || deleting) return;

    try {
      setDeleting(true);

      const token = getToken();

      const res = await fetch(
        "https://khata.moxpal.com/api/v2/index.php?path=khata/delete",
        {
          method: "POST",

          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type":
              "application/json",
          },

          body: JSON.stringify({
            business_name:
              value.trim(),
          }),
        }
      );

      const json = await res.json();

      setDeleting(false);

      if (json.success) {
        alert(
          t(
            LangKeys.khatabook_deleted_success
          )
        );

        localStorage.clear();

        window.location.href =
          "/login";
      } else {
        alert(
          json?.error?.message ||
            t(
              LangKeys.something_went_wrong
            )
        );
      }
    } catch (e) {
      console.log(e);

      setDeleting(false);

      alert(
        t(
          LangKeys.something_went_wrong
        )
      );
    }
  };

  // =====================================================
  // LOADING
  // =====================================================

  if (loading) {
    return (
      <div style={styles.loading}>
        {t(LangKeys.loading)}
      </div>
    );
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.warning}>
          {t(
            LangKeys.delete_warning_text
          )}
        </div>

        <div style={styles.businessName}>
          {businessName}
        </div>

        <input
          value={value}
          onChange={(e) =>
            checkMatch(e.target.value)
          }
          placeholder={t(
            LangKeys.delete_placeholder
          )}
          style={styles.input}
        />

        <button
          onClick={confirmDelete}
          disabled={
            !canDelete || deleting
          }
          style={{
            ...styles.button,

            backgroundColor:
              canDelete
                ? "#DC2626"
                : "#E5E7EB",

            color: canDelete
              ? "#fff"
              : "#9CA3AF",

            cursor: canDelete
              ? "pointer"
              : "not-allowed",
          }}
        >
          {deleting
            ? t(LangKeys.loading)
            : t(
                LangKeys.delete_button
              )}
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: {
    padding: "16px",
  },

  loading: {
    padding: "20px",
    fontSize: "14px",
    color: "#64748B",
  },

  card: {
    backgroundColor: "#fff",
    borderRadius: "16px",
    padding: "18px",
    border: "1px solid #E5E7EB",
    boxShadow:
      "0 6px 16px rgba(0,0,0,0.06)",
  },

  warning: {
    fontSize: "14px",
    color: "#B91C1C",
    lineHeight: "1.6",
  },

  businessName: {
    marginTop: "12px",
    fontSize: "15px",
    fontWeight: "700",
    color: "#111827",
  },

  input: {
    width: "100%",
    height: "52px",
    marginTop: "18px",
    borderRadius: "12px",
    border:
      "2px solid #C7D2FE",

    backgroundColor: "#F9FAFB",

    padding: "0 14px",

    fontSize: "14px",

    outline: "none",

    boxSizing: "border-box",
  },

  button: {
    width: "100%",
    height: "52px",
    marginTop: "20px",
    border: "none",
    borderRadius: "14px",
    fontSize: "15px",
    fontWeight: "700",
  },
};

export default DeleteKhataPage;